import { random } from 'lodash'

export function getRandomString({ length = 12, withNumbers = true } = {}) {
  let parts = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  if (withNumbers) {
    parts += '0123456789'
  }
  return Array(length)
    .fill()
    .map(() => {
      const idx = random(0, parts.length - 1)
      return parts[idx]
    })
    .join('')
}
